import { FormControl, OutlinedInput } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import React from 'react';

export interface Props {
  id: string;
  label: string;
  isLoading: boolean;
  onSearch: (value: string) => void;
}

const ActionSearch = ({ id, label, isLoading, onSearch }: Props) => {
  const [searchValue, setSearchValue] = React.useState('');

  const [isSearchLocked, setIsSearchLocked] = React.useState(false);

  const initiateSearch = searchValue => {
    if (isSearchLocked || isLoading) return;
    setIsSearchLocked(true);

    onSearch(searchValue);

    setTimeout(() => {
      setIsSearchLocked(false);
    }, 150);
  };

  return (
    <React.Fragment>
      <FormControl
        fullWidth
        variant="outlined"
        data-testid={'autosky-actionsearch'}
      >
        <OutlinedInput
          id={id}
          onChange={({ target }) => setSearchValue(target.value)}
          endAdornment={<SearchIcon />}
          labelWidth={0}
          placeholder={label}
          onKeyPress={e => {
            if (e.key === 'Enter') {
              e.preventDefault();
              initiateSearch(searchValue);
            }
          }}
        />
      </FormControl>
    </React.Fragment>
  );
};

export default ActionSearch;
